<template>
  <div class="artist-info">
    <TextField
      :id="'artist_name'"
      v-bind="textFieldConfig"
      :value="artist.artist_name"
      :placeholder="$t('artist')"
      disabled
      @valuechanged="onTextfieldValueChangd"
      @validated="onValidation"
    ></TextField>
    <TextField
      :id="'first_offer_notes'"
      v-bind="textFieldConfig"
      :value="artist.first_offer_notes"
      :placeholder="$t('first_offer')"
      @valuechanged="onTextfieldValueChangd"
      @validated="onValidation"
    ></TextField>
    <TextField
      :id="'performance_time'"
      v-bind="textFieldConfig"
      :value="artist.performance_time"
      :placeholder="$t('performance_time')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField
      :id="'performance_time_contract'"
      v-bind="textFieldConfig"
      :value="artist.performance_time_contract"
      :placeholder="$t('playtime')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField
      :id="'artist_soundcheck'"
      v-bind="textFieldConfig"
      :value="artist.artist_soundcheck"
      :placeholder="$t('soundcheck')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField  
      :id="'artist_before'"
      v-bind="textFieldConfig"
      :value="artist.artist_before"
      :placeholder="$t('artist_before')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField 
      :id="'artist_after'"
      v-bind="textFieldConfig"
      :value="artist.artist_after"
      :placeholder="$t('rs_artist_after')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
    <TextField 
      :id="'artist_stage_floor'"
      v-bind="textFieldConfig"
      :value="artist.artist_stage_floor"
      :placeholder="$t('stage_floor')"
      @validated="onValidation"
      @valuechanged="onTextfieldValueChangd"
    ></TextField>
  </div>
</template>

<script>
import TextField from '@plugins/text-field/text-field';
import { createArtist } from './cdate.model';

export default {
  components: {
    TextField
  },
  props: {
    artist: {
      required: true,
      type: Object,
      default: () => createArtist()
    },
  },
  data: function() {
    return {
      validationResult: {},

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        statusInside: true,
      },
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  
  methods: {
    onTextfieldValueChangd: function(name, value) {
      this.$emit('changed', {name, value});
    },
    onValidation: function(id, validationResult) {
      this.$set(this.validationResult, id, validationResult);
    },
  }
}
</script>


<style lang="scss" scoped>
  .dropdown.box {
    margin: 5px;
  }
</style>
